import Menu from './Compartido/Menu.jsx';
import FormularioLogin from './Login/FormularioLogin.jsx';
import Footer from './Compartido/Footer.jsx';

const Login = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <FormularioLogin
                lang={props.lang}
                config={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Login;
